import { createRouter } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'
import { queryClient } from './lib/query-client'
import type { QueryClient } from '@tanstack/react-query'
import type { AuthContextType } from '@/context/auth-context'
import NotFound from '@/pages/NotFound'

const initialAuthContext: AuthContextType = {
  userInfo: undefined,
  loading: false,
  isActive: false,
  isAuthenticated: false,
}

export const router = createRouter({
  routeTree,
  context: {
    queryClient,
    auth: initialAuthContext,
  },
  defaultNotFoundComponent: NotFound,
  defaultPreload: 'intent',
  defaultPendingMs: 0,
  defaultPendingMinMs: 0,
  defaultStaleTime: 30_000,
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }

  interface RouterContext {
    queryClient: QueryClient
    auth: AuthContextType
  }
}
